import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Variables } from "../../Variables1/Variables";
import validator from "validator";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Row,
  Col,
  Image,
  Form,
  Button,
  Spinner,
  FormCheck,
} from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import Cookies from "js-cookie";

function ManageRole(props) {
  const RoleRouteId = useParams();
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const [Permissions, setPermissions] = useState(
    Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  );

  const [roleId, setRoleId] = useState(Number(RoleRouteId.RoleRouteId) || 0);

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const [roleDetails, setRoleDetails] = useState({
    RoleId: 0,
    RoleName: "",
    ViewUsers: false,
    ManageUsers: false,
    ViewLanguages: false,
    ManageLanguages: false,
    ViewDirections: false,
    ManageDirections: false,
    ViewWidgets: false,
    ManageWidgets: false,
    ViewMenues: false,
    ManageMenues: false,
    ViewAuthors: false,
    ManageAuthors: false,
    ViewAlbums: false,
    ManageAlbums: false,
    ViewAlbumItems: false,
    ManageAlbumItems: false,
    ViewCustomFieldsType: false,
    ManageCustomFieldsType: false,
    ViewCustomFieldData: false,
    ManageCustomFieldData: false,
    ViewContents: false,
    ManageContents: false,
    ViewRoles: false,
    ManageRoles: false,
  });

  // Get role details
  const GetRoleDetails = async () => {
    let response = await fetch(
      Variables.API_URL + "Role/GetRoleDetails/" + roleId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      setRoleDetails(result);
    }
  };

  const HandleNameInput = (e) => {
    const { name, value } = e.target;
    console.log("value", value);
    var element;
    if (value == "") {
      element = document.getElementById(name);
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById(name);
      element.classList.remove("is-invalid");
    }
    setRoleDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle IsPublished
  const HandleInput = (e) => {
    const { name, value } = e.target;
    console.log("name " + name + " value " + value);
    if (value == "true") {
      console.log("tru");
      setRoleDetails((prevState) => ({
        ...prevState,
        [name]: false,
      }));
    } else {
      setRoleDetails((prevState) => ({
        ...prevState,
        [name]: true,
      }));
    }

    // if (contentDetails.IsPublished === true) {
    //   setContentDetails((prevState) => ({
    //     ...prevState,
    //     IsPublished: false,
    //   }));
    // } else {
    //   setContentDetails((prevState) => ({
    //     ...prevState,
    //     IsPublished: true,
    //   }));
    // }
  };

  // Add Role
  const AddRole = async () => {
    setButtonLoader(true);
    let response = await fetch(Variables.API_URL + "Role/AddNewRole", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        RoleId: roleId,
        RoleName: roleDetails.RoleName,
        ViewUsers: roleDetails.ViewUsers,
        ManageUsers: roleDetails.ManageUsers,
        ViewLanguages: roleDetails.ViewLanguages,
        ManageLanguages: roleDetails.ManageLanguages,
        ViewDirections: roleDetails.ViewDirections,
        ManageDirections: roleDetails.ManageDirections,
        ViewWidgets: roleDetails.ViewWidgets,
        ManageWidgets: roleDetails.ManageWidgets,
        ViewMenues: roleDetails.ViewMenues,
        ManageMenues: roleDetails.ManageMenues,
        ViewAuthors: roleDetails.ViewAuthors,
        ManageAuthors: roleDetails.ManageAuthors,
        ViewAlbums: roleDetails.ViewAlbums,
        ManageAlbums: roleDetails.ManageAlbums,
        ViewAlbumItems: roleDetails.ViewAlbumItems,
        ManageAlbumItems: roleDetails.ManageAlbumItems,
        ViewCustomFieldsType: roleDetails.ViewCustomFieldsType,
        ManageCustomFieldsType: roleDetails.ManageCustomFieldsType,
        ViewCustomFieldData: roleDetails.ViewCustomFieldData,
        ManageCustomFieldData: roleDetails.ManageCustomFieldData,
        ViewContents: roleDetails.ViewContents,
        ManageContents: roleDetails.ManageContents,
        ViewRoles: roleDetails.ViewRoles,
        ManageRoles: roleDetails.ManageRoles,
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setTimeout(() => {
        navigate("/Role");
      }, 1000);
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setButtonLoader(false);
  };

  // Add Role
  const UpdateRole = async () => {
    setButtonLoader(true);
    let response = await fetch(Variables.API_URL + "Role/UpdateRole", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        RoleId: roleId,
        RoleName: roleDetails.RoleName,
        ViewUsers: roleDetails.ViewUsers,
        ManageUsers: roleDetails.ManageUsers,
        ViewLanguages: roleDetails.ViewLanguages,
        ManageLanguages: roleDetails.ManageLanguages,
        ViewDirections: roleDetails.ViewDirections,
        ManageDirections: roleDetails.ManageDirections,
        ViewWidgets: roleDetails.ViewWidgets,
        ManageWidgets: roleDetails.ManageWidgets,
        ViewMenues: roleDetails.ViewMenues,
        ManageMenues: roleDetails.ManageMenues,
        ViewAuthors: roleDetails.ViewAuthors,
        ManageAuthors: roleDetails.ManageAuthors,
        ViewAlbums: roleDetails.ViewAlbums,
        ManageAlbums: roleDetails.ManageAlbums,
        ViewAlbumItems: roleDetails.ViewAlbumItems,
        ManageAlbumItems: roleDetails.ManageAlbumItems,
        ViewCustomFieldsType: roleDetails.ViewCustomFieldsType,
        ManageCustomFieldsType: roleDetails.ManageCustomFieldsType,
        ViewCustomFieldData: roleDetails.ViewCustomFieldData,
        ManageCustomFieldData: roleDetails.ManageCustomFieldData,
        ViewContents: roleDetails.ViewContents,
        ManageContents: roleDetails.ManageContents,
        ViewRoles: roleDetails.ViewRoles,
        ManageRoles: roleDetails.ManageRoles,
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setButtonLoader(false);
  };

  const HandleSubmit = () => {
    if (roleDetails.RoleName != "") {
      // case of insert
      if (roleId === 0) {
        AddRole();
      }
      // case of update
      else {
        console.log("update");
        UpdateRole();
      }
    } else {
      var element = document.getElementById("RoleName");
      element.classList.add("is-invalid");
      toast.error("Please select role name", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
    
      if (roleId != 0) {
        GetRoleDetails();
      }
  }, []);

  return (
    <div>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">
                  {roleId === 0
                    ? "Add New Role"
                    : "Manage Role --> " + roleDetails.RoleName}
                </h4>
              </div>
            </Card.Header>
            <Card.Body>
              {loader === true ? (
                <CustomSnipper />
              ) : (
                <div>
                  <Row>
                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">Role Name:</Form.Label>
                      <Form.Control
                        id="RoleName"
                        name="RoleName"
                        placeholder="Role Name"
                        type="text"
                        value={roleDetails.RoleName}
                        onChange={HandleNameInput}
                      />
                    </Form.Group>
                  </Row>
                  <Row>
                    {/* Users */}
                    <Form.Group className="col-md-6 form-group">
                      <Row>
                        <Form.Label className="fontBold">Users : </Form.Label>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ViewUsers"
                              name="ViewUsers"
                              value={roleDetails.ViewUsers}
                              checked={roleDetails.ViewUsers}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              View Users
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>

                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ManageUsers"
                              name="ManageUsers"
                              value={roleDetails.ManageUsers}
                              checked={roleDetails.ManageUsers}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              Manage Users
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>
                      </Row>
                    </Form.Group>

                    {/* Languages */}
                    <Form.Group className="col-md-6 form-group">
                      <Row>
                        <Form.Label className="fontBold">
                          Languages :{" "}
                        </Form.Label>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ViewLanguages"
                              name="ViewLanguages"
                              value={roleDetails.ViewLanguages}
                              checked={roleDetails.ViewLanguages}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              View Languages
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>

                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ManageLanguages"
                              name="ManageLanguages"
                              value={roleDetails.ManageLanguages}
                              checked={roleDetails.ManageLanguages}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              Manage Languages
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>
                      </Row>
                    </Form.Group>

                    {/* Directions */}
                    <Form.Group className="col-md-6 form-group">
                      <Row>
                        <Form.Label className="fontBold">
                          Directions :{" "}
                        </Form.Label>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ViewDirections"
                              name="ViewDirections"
                              value={roleDetails.ViewDirections}
                              checked={roleDetails.ViewDirections}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              View Directions
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>

                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ManageDirections"
                              name="ManageDirections"
                              value={roleDetails.ManageDirections}
                              checked={roleDetails.ManageDirections}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              Manage Directions
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>
                      </Row>
                    </Form.Group>

                    {/* Widgets */}
                    <Form.Group className="col-md-6 form-group">
                      <Row>
                        <Form.Label className="fontBold">Widgets : </Form.Label>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ViewWidgets"
                              name="ViewWidgets"
                              value={roleDetails.ViewWidgets}
                              checked={roleDetails.ViewWidgets}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              View Widgets
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>

                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ManageWidgets"
                              name="ManageWidgets"
                              value={roleDetails.ManageWidgets}
                              checked={roleDetails.ManageWidgets}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              Manage Widgets
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>
                      </Row>
                    </Form.Group>

                    {/* Menus */}
                    <Form.Group className="col-md-6 form-group">
                      <Row>
                        <Form.Label className="fontBold">Menus : </Form.Label>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ViewMenues"
                              name="ViewMenues"
                              value={roleDetails.ViewMenues}
                              checked={roleDetails.ViewMenues}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              View Menues
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>

                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ManageMenues"
                              name="ManageMenues"
                              value={roleDetails.ManageMenues}
                              checked={roleDetails.ManageMenues}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              Manage Menues
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>
                      </Row>
                    </Form.Group>

                    {/* Authors */}
                    <Form.Group className="col-md-6 form-group">
                      <Row>
                        <Form.Label className="fontBold">Authors : </Form.Label>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ViewAuthors"
                              name="ViewAuthors"
                              value={roleDetails.ViewAuthors}
                              checked={roleDetails.ViewAuthors}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              View Authors
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>

                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ManageAuthors"
                              name="ManageAuthors"
                              value={roleDetails.ManageAuthors}
                              checked={roleDetails.ManageAuthors}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              Manage Authors
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>
                      </Row>
                    </Form.Group>

                    {/* Albums */}
                    <Form.Group className="col-md-6 form-group">
                      <Row>
                        <Form.Label className="fontBold">Albums : </Form.Label>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ViewAlbums"
                              name="ViewAlbums"
                              value={roleDetails.ViewAlbums}
                              checked={roleDetails.ViewAlbums}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              View Albums
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>

                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ManageAlbums"
                              name="ManageAlbums"
                              value={roleDetails.ManageAlbums}
                              checked={roleDetails.ManageAlbums}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              Manage Albums
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>
                      </Row>
                    </Form.Group>

                    {/* Album Items */}
                    <Form.Group className="col-md-6 form-group">
                      <Row>
                        <Form.Label className="fontBold">
                          Album Items :{" "}
                        </Form.Label>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ViewAlbumItems"
                              name="ViewAlbumItems"
                              value={roleDetails.ViewAlbumItems}
                              checked={roleDetails.ViewAlbumItems}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              View Album Items
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>

                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ManageAlbumItems"
                              name="ManageAlbumItems"
                              value={roleDetails.ManageAlbumItems}
                              checked={roleDetails.ManageAlbumItems}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              Manage Album Items
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>
                      </Row>
                    </Form.Group>

                    {/* Custom Filed Type */}
                    <Form.Group className="col-md-6 form-group">
                      <Row>
                        <Form.Label className="fontBold">
                          Custom Field Type :{" "}
                        </Form.Label>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ViewCustomFieldsType"
                              name="ViewCustomFieldsType"
                              value={roleDetails.ViewCustomFieldsType}
                              checked={roleDetails.ViewCustomFieldsType}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              View Custom Fields Type
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>

                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ManageCustomFieldsType"
                              name="ManageCustomFieldsType"
                              value={roleDetails.ManageCustomFieldsType}
                              checked={roleDetails.ManageCustomFieldsType}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              Manage Custom Fields Type
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>
                      </Row>
                    </Form.Group>

                    {/* Custom Filed Data */}
                    <Form.Group className="col-md-6 form-group">
                      <Row>
                        <Form.Label className="fontBold">
                          Custom Field Data :{" "}
                        </Form.Label>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ViewCustomFieldData"
                              name="ViewCustomFieldData"
                              value={roleDetails.ViewCustomFieldData}
                              checked={roleDetails.ViewCustomFieldData}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              View Custom Field Data
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>

                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ManageCustomFieldData"
                              name="ManageCustomFieldData"
                              value={roleDetails.ManageCustomFieldData}
                              checked={roleDetails.ManageCustomFieldData}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              Manage Custom Fields Data
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>
                      </Row>
                    </Form.Group>

                    {/* Contents */}
                    <Form.Group className="col-md-6 form-group">
                      <Row>
                        <Form.Label className="fontBold">
                          Contents :{" "}
                        </Form.Label>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ViewContents"
                              name="ViewContents"
                              value={roleDetails.ViewContents}
                              checked={roleDetails.ViewContents}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              View Contents
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>

                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ManageContents"
                              name="ManageContents"
                              value={roleDetails.ManageContents}
                              checked={roleDetails.ManageContents}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              Manage Contents
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>
                      </Row>
                    </Form.Group>

                    {/* Roles */}
                    <Form.Group className="col-md-6 form-group">
                      <Row>
                        <Form.Label className="fontBold">Roles : </Form.Label>
                      </Row>
                      <Row>
                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ViewRoles"
                              name="ViewRoles"
                              value={roleDetails.ViewRoles}
                              checked={roleDetails.ViewRoles}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              View Roles
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>

                        <Form.Group className="col-md-6 form-group">
                          <Form.Check className="mb-3 form-check">
                            <FormCheck.Input
                              type="checkbox"
                              className=""
                              id="ManageRoles"
                              name="ManageRoles"
                              value={roleDetails.ManageRoles}
                              checked={roleDetails.ManageRoles}
                              onChange={(e) => HandleInput(e)}
                            />
                            <FormCheck.Label
                              className=""
                              htmlFor="exampleCheck1"
                            >
                              Manage Roles
                            </FormCheck.Label>
                          </Form.Check>
                        </Form.Group>
                      </Row>
                    </Form.Group>
                  </Row>
                </div>
              )}
              <hr />

              <div className="float-right">
                <Button
                  type="button"
                  variant="btn btn-primary"
                  onClick={HandleSubmit}
                >
                  {buttonLoader == true ? (
                    <Spinner animation="border" variant="light" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  ) : (
                    "Submit"
                  )}
                </Button>{" "}
                <Button
                  type="button"
                  variant="btn btn-secondary"
                  onClick={() => navigate("/Role")}
                >
                  Cancel
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default ManageRole;
